import { ProductModalErrorTypes } from "src/features/product-modal/model/ProductModalError";
import { ProductModalErrors } from "../model/ProductModalError";
import { EnabledVariants } from "./get-enabled-variants";
import isColorVariant from "./is-color-variant";
import isSizeVariant from "./is-size-variant";

type ShowColor = boolean;
type HasColorError = boolean;
type ShowSize = boolean;
type HasSizeError = boolean;

const getVariantStatus = (
  enabledVariants: EnabledVariants,
  errors: ProductModalErrors
): [ShowColor, HasColorError, ShowSize, HasSizeError] => {
  const showColor = Boolean(enabledVariants?.Color);
  const hasColorError = errors[ProductModalErrorTypes.UnselectedVariant].some(
    (error) => isColorVariant(error.key)
  );
  const showSize = Boolean(enabledVariants?.Size);
  const hasSizeError = errors[ProductModalErrorTypes.UnselectedVariant].some(
    (error) => isSizeVariant(error.key)
  );

  return [showColor, hasColorError, showSize, hasSizeError];
};

export default getVariantStatus;
